<template>
  <div class="custom-container" v-loading.fullscreen.lock="brand.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="brand-title">Create Brand</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form label-position="left" ref="formBrand" label-width="150px" :model="formBrand">
          <Form :Brand="formBrand" from="create"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    formBrand: {
      brandCode: "",
      brandName: "",
      description: "",
      brandLogo: "",
      is_active: true,
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      brand: state => state.brand.brand
    })
  },
  methods: {
    ...mapActions({
      createBrand: "brand/CreateBrand"
    }),
    save() {
      this.$refs.formBrand.validate(valid => {
        if (valid) {
          this.createBrand(this.formBrand);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
</style>
